import { defineMessages } from 'react-intl';

export default defineMessages({
  select: {
    id: 'components.SelectBox.select',
    defaultMessage: 'Select {option}',
  },
});
